import React, { useState } from 'react';
import { FaWhatsapp } from 'react-icons/fa';

/**
 * Floating WhatsApp Quick Connect Button
 * Directs clients to official Core Spectators WhatsApp channel with a pre-filled discovery prompt.
 */
const WhatsAppButton = ({
  phoneNumber = '13323788142',
  defaultMessage = 'Hello Core Spectators, I would like to inquire about a Shopify store, Mobile App, SaaS MVP, or AI Automation project.'
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const encodedMessage = encodeURIComponent(defaultMessage);
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;

  return (
    <div
      className="fixed bottom-6 right-6 z-40 flex items-center gap-3 group"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Interactive Tooltip Badge */}
      <div
        className={`hidden sm:flex items-center gap-2 bg-gray-950/95 text-white px-3.5 py-2 rounded-xl shadow-2xl border border-gray-800 text-xs font-semibold backdrop-blur-md transition-all duration-300 transform ${isHovered ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-4 pointer-events-none'
          }`}
      >
        <span className="w-2 h-2 rounded-full bg-emerald-400 animate-ping inline-block"></span>
        <span>Chat with an Architect on WhatsApp</span>
      </div>

      {/* Main Floating Button */}
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat with Core Spectators on WhatsApp"
        className="relative flex items-center justify-center w-14 h-14 sm:w-15 sm:h-15 rounded-full bg-gradient-to-tr from-[#20ba59] via-[#25D366] to-[#128C7E] text-white shadow-[0_8px_25px_rgba(37,211,102,0.45)] hover:shadow-[0_12px_32px_rgba(37,211,102,0.65)] hover:scale-110 active:scale-95 transition-all duration-300 ease-out focus:outline-none focus:ring-4 focus:ring-emerald-400/40"
      >
        {/* Subtle Pulse Radar Ring */}
        <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-30 animate-ping pointer-events-none"></span>

        {/* WhatsApp Icon */}
        <FaWhatsapp className="text-3xl sm:text-3xl text-white drop-shadow-md z-10" aria-hidden="true" />

        {/* Active Online Indicator Pill */}
        <span className="absolute top-0 right-0 w-3.5 h-3.5 bg-emerald-400 border-2 border-white rounded-full z-20"></span>
      </a>
    </div>
  );
};

export default WhatsAppButton;
